<template>
    <div v-if="field" class="field">
        <CodeEditor v-model="content" :withButton="false" :readOnly="field.protected"></CodeEditor>
        <p class="errorMsg"> {{ errorMsg }} </p>
    </div>
</template>

<style scoped>
div.field {
    padding: 10px;
}

.errorMsg {
    color: red;
    font-size: 12px;
}

.field-datajson-hide {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.1);
    display: flex;
    cursor: not-allowed;
}

.show-data {
    position: relative;
}
</style>

<script>
import _ from 'lodash'

export default {
    name: "IdentityFieldDataJson",
    components: {
        CodeEditor: () => import('../../../form/Editor/Code')
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Object|Array
        },
        store: {
            type: Object
        },
        context: {
            type: Object
        }
    },
    data: function() {
        return {
            errors: [],
            httpErrors: [],
            model: {},
            editor: false,
            showCode: false,
            errorMsg: '',
            errorModal: {
                show: false,
                msg: null
            },
        }
    },
    computed: {
        content: {
            get() {
                try {
                    this.errorMsg = '' 
                    return JSON.stringify(this.value || {}, null, 2)
                } catch(err) {
                    this.errorMsg = err
                }
            },

            set(val) {
                try {
                    this.errorMsg = '' 
                    this.$emit('input', JSON.parse(val))
                } catch(err) {
                    this.errorMsg = err
                }
            }
        }
    },
    methods: {
    },

    created() {
    }

}
</script>